import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { tgoa } from '../features/search/util';

function ProfileUser(props) {
  const [isOpen, setIsOpen] = useState(false);
  const toggleOpen = () => setIsOpen(!isOpen);

  let institution = props.authID.i;
  let instVerify;

  try {
    instVerify = (institution.length === undefined) ? institution : JSON.parse(atob(institution));
  } catch (error) { }
  if (instVerify === " ") { instVerify = null; }

  let institutionName = 'My Account';

  let parsedInstition;
  if (props.authID.u.i !== undefined) {
    parsedInstition = props.authID.u.i;
  } else {
    const email = props.authID.u['signInNames.emailAddress'];
    const tgoaEmail = 'member@' + email.split('@')[1];
    parsedInstition = tgoa[tgoaEmail];
  }
  
  if (parsedInstition !== undefined) {
    institutionName = `Access provided by ${parsedInstition}`;
  } else if (props.authID.u.i !== undefined) {
    institutionName = `Access provided by ${props.authID.u.i}`;
  }
  const userButton =<li><Link id="subscribeBtn" rel="noreferrer" href="#" to="/showMyProfile"  className="btn btn-lg btn-info btn-block"><small>{props.authID.u.given_name} {props.authID.u.family_name}</small></Link></li>;

  return (
    <>
      {
        instVerify ?
          <a id="instBtn" rel="noreferrer" href="#accessbutton" disabled className="btn btn-danger btn-block"><small>Access by {instVerify.name}</small></a>
         : " "
      }
        <div>
          <div className='btn-group'>
            <button id="myaccount-btn" type="button" className="btn btn-info dropdown-toggle dropbtn active" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" onClick={toggleOpen}>
              <small>{institutionName}</small>  <span className="caret"></span>
            </button>


            <ul id="myaccount-menu" className={`dropdown-menu ${isOpen ? 'show' : ''}`} role="menu">
              {userButton}
              <li><Link id="logInbtn" href="#" title="Log in" onClick={props.handleLogout} data-target="#tglogin" className="btn btn-lg btn-info btn-block"><small>Log out</small></Link></li>
            </ul>
          </div>
        </div>
    </>
  );
}

export default ProfileUser;

ProfileUser.propTypes = {
  authID: PropTypes.shape({
    i: PropTypes.shape({
      name: PropTypes.string,
    }),
    u: PropTypes.shape({
      given_name: PropTypes.string,
    }),
  }).isRequired,
  handleLogout: PropTypes.func.isRequired,
  handleEditProfile: PropTypes.func.isRequired,
};